import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04fd3ad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-label"]
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("td", {
    class: "data-table__cell",
    "data-label": _ctx.label
  }, [
    _createElementVNode("span", {
      title: _ctx.text?.toString()
    }, [
      _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 8, _hoisted_2)
  ], 8, _hoisted_1))
}